<template>
  <div class="rounded-t-lg px-3 py-2.5">
    <slot></slot>
  </div>
</template>
